import CustomerSystemsOverview from "../../../components/dashboard/customers/systems/CustomerSystemsOverview";

export function SystemsPage() {
  return <CustomerSystemsOverview standalone />;
}
